import React from 'react';
import { func, number } from 'prop-types';

import { Row, Col, Input, Typography } from '@ajaibid/components';
import SvgIcon from 'Component/SvgIcon';

import { useStockBuySellContext, useValidateForm } from '../../../hooks';

const InputPrice = (props) => {
  const { marginTop, marginBottom, onSubmit } = props;

  const { code, formState, formKey, formAction, dispatch } = useStockBuySellContext();
  const { isFormValidated } = useValidateForm();

  const onEnter = () => {
    if (isFormValidated) {
      onSubmit();
    }
  };

  return (
    <Row noGutters marginTop={marginTop} marginBottom={marginBottom}>
      <Col size={3}>
        <Typography type="body" bold margin={0}>
          Harga
        </Typography>
      </Col>
      <Col size={9}>
        <Input.Number
          id={formKey.INPUT_PRICE}
          name={formKey.INPUT_PRICE}
          block
          size="sm"
          value={formState[formKey.INPUT_PRICE]}
          onChange={(e) =>
            dispatch({ type: formAction.CHANGE_PRICE, code, payload: e.target.value })
          }
          onEnter={onEnter}
          prepend={<SvgIcon name="rupiah" width={20} height={20} />}
        />
      </Col>
    </Row>
  );
};

InputPrice.propTypes = {
  marginTop: number,
  marginBottom: number,
  onSubmit: func,
};

InputPrice.defaultProps = {
  marginTop: 0,
  marginBottom: 0,
  onSubmit: () => {},
};

export default InputPrice;
